import { AsyncPipe } from '@angular/common';
import { Component, inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslocoModule } from '@ngneat/transloco';
import { ChiplistAutocompleteComponent } from '../chiplist-ac/chiplist-ac.component';
import { isEqual } from 'lodash-es';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { LocalizePipe } from '../../pipes/standalone/localize.pipe';
import { Net2BeepleLocator } from '../../dtype/dtype.types';
import { EndpointsService } from '../../../modules/admin/endpoints/endpoints.service';
import { Utils } from '../../utils/utils';

@Component({
    selector: 'worker-chiplist-ac',
    templateUrl: '../chiplist-ac/chiplist-ac.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [AsyncPipe, FormsModule, MatAutocompleteModule, MatChipsModule, MatFormFieldModule, MatIconModule, MatInputModule, LocalizePipe, ReactiveFormsModule, TranslocoModule]
})
export class WorkerChiplistAcComponent extends ChiplistAutocompleteComponent {

    @Input() locator: Net2BeepleLocator;
    private endpointsService = inject(EndpointsService);

    async add(event: MatChipInputEvent) {
        const value = event.value;
        if (value) {
            if (!this.idExistsInChiplist(value)) {
                const selectedOptions = this.control.value;

                // Busca en las opciones el trabajador
                let worker = this.getOptionByIdFromList(value, this.option);

                // Busca en backend el trabajador en caso de que las opciones no se hayan actualizado 
                if (!worker) {
                    const workers = await firstValueFrom(this.endpointsService.searchDBNet4Worker({ expr: value, locator: this.locator }));
                    worker = this.getOptionByIdFromList(value, workers);
                    if(worker)
                        worker.displayName = value + " " + worker.displayName;
                }

                // Crea un trabajador no existente 
                if (!worker && /^[0-9]+$/.test(value)){
                    worker = {trabajadorNet4Id: value, displayName: value};
                }

                if (worker) {
                    selectedOptions.push(worker);
                    this.control.setValue(selectedOptions);
                }
            }
        }
        event.chipInput.clear();
        this.searchCtrl.setValue(null);
    }

    private idExistsInChiplist(id): boolean {
        return this.control.value.find(v => typeof v === 'string' || typeof v === 'number' ? v == id :
            this.id ? v[this.id] == id : isEqual(v, id))
    }

    private getOptionByIdFromList(id, list) {
        return list.find(o => typeof o[this.id] === 'string' ? Utils.removeAccents(o[this.id]).toLowerCase() === Utils.removeAccents(id).toLowerCase() 
            : o[this.id] == id);
    }
}
